module.exports = __webpack_public_path__ + "img/reservas.9b170897.jpeg";